// import { useEffect, useState } from 'react';
import './bottom.css';
function Bottom() {
    
    return (
        <div id="bottom">
            <div className="bottom_title font_big">Dự án Otin Store</div>

            <div className="bottom_content"></div>
            <div className='bottom_pic'></div>
        </div>
    );
}

export default Bottom;
